(() => {
  const MOBILE_BREAKPOINT = 749;

  const injectFooterPopupStyles = () => {
    if (document.getElementById('gc-2026-footer-popup-styles')) return;

    const style = document.createElement('style');
    style.id = 'gc-2026-footer-popup-styles';

    style.textContent = `
      /* =====================================================
         GREENCHEF 2026 FOOTER COUNTRY POPUP
      ===================================================== */

      .gc-2026-country-backdrop {
        position: fixed;
        inset: 0;
        z-index: 999998;
        display: none;
        background: rgba(0, 0, 0, 0.68);
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
      }

      .gc-2026-country-backdrop.is-visible {
        display: block;
      }

      body.gc-2026-country-popup-open {
        overflow: hidden;
        overscroll-behavior: none;
      }

      @media screen and (max-width: 749px) {
        [data-gc-country-panel].gc-2026-country-panel--mobile {
          position: fixed !important;
          top: 50% !important;
          right: auto !important;
          bottom: auto !important;
          left: 50% !important;

          z-index: 999999 !important;

          display: flex !important;
          flex-direction: column !important;

          width: calc(100vw - 32px) !important;
          max-width: 420px !important;
          height: auto !important;
          max-height: min(72vh, 620px) !important;

          margin: 0 !important;
          padding: 10px !important;

          overflow: hidden !important;

          background: #292929 !important;
          border: 1px solid rgba(255, 255, 255, 0.18) !important;
          border-radius: 18px !important;
          box-shadow:
            0 24px 60px rgba(0, 0, 0, 0.55),
            0 4px 18px rgba(0, 0, 0, 0.32) !important;

          transform: translate(-50%, -50%) !important;

          animation: gcCountryPopupOpen 0.22s ease both;
        }

        [data-gc-country-panel].gc-2026-country-panel--mobile[hidden] {
          display: none !important;
        }

        [data-gc-country-panel].gc-2026-country-panel--mobile
          [data-gc-country-search] {
          width: 100% !important;
          min-width: 0 !important;
          height: 44px !important;
          margin: 0 !important;
          padding: 0 46px 0 14px !important;

          background: #252525 !important;
          color: #ffffff !important;
          border: 1px solid rgba(255, 255, 255, 0.28) !important;
          border-radius: 10px !important;
          box-sizing: border-box !important;
        }

        [data-gc-country-panel].gc-2026-country-panel--mobile
          [data-gc-country-close] {
          position: absolute !important;
          top: 10px !important;
          right: 10px !important;

          z-index: 3 !important;

          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;

          width: 38px !important;
          height: 44px !important;
          margin: 0 !important;
          padding: 0 !important;

          color: #718e3f !important;
          background: transparent !important;
          border: 0 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
        }

        [data-gc-country-panel].gc-2026-country-panel--mobile
          ul {
          flex: 1 1 auto !important;

          max-height: calc(72vh - 74px) !important;
          margin: 10px 0 0 !important;
          padding: 0 !important;

          overflow-x: hidden !important;
          overflow-y: auto !important;
          overscroll-behavior: contain !important;
          -webkit-overflow-scrolling: touch !important;

          scrollbar-width: thin;
        }

        [data-gc-country-panel].gc-2026-country-panel--mobile
          li {
          width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        [data-gc-country-panel].gc-2026-country-panel--mobile
          [data-gc-country-option] {
          width: 100% !important;
          min-height: 42px !important;
          margin: 0 !important;
          padding: 10px 12px !important;
          box-sizing: border-box !important;
        }

        @keyframes gcCountryPopupOpen {
          from {
            opacity: 0;
            transform: translate(-50%, -46%) scale(0.97);
          }

          to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }
      }
    `;

    document.head.appendChild(style);
  };

  const initFooter = (scope = document) => {
    injectFooterPopupStyles();

    scope.querySelectorAll('[data-gc-2026-footer]').forEach((footer) => {
      if (footer.dataset.gcFooterInitialized === 'true') return;
      footer.dataset.gcFooterInitialized = 'true';

      const accordions = footer.querySelectorAll(
        '[data-gc-footer-accordion]'
      );

      accordions.forEach((accordion) => {
        const button = accordion.querySelector(
          '[data-gc-footer-accordion-button]'
        );

        const content = accordion.querySelector(
          '[data-gc-footer-accordion-content]'
        );

        const icon = accordion.querySelector(
          '[data-gc-footer-accordion-icon]'
        );

        if (!button || !content) return;

        button.addEventListener('click', () => {
          if (window.innerWidth > MOBILE_BREAKPOINT) return;

          const willOpen = !accordion.classList.contains('is-open');

          accordions.forEach((otherAccordion) => {
            if (otherAccordion === accordion) return;

            otherAccordion.classList.remove('is-open');

            const otherButton = otherAccordion.querySelector(
              '[data-gc-footer-accordion-button]'
            );

            const otherIcon = otherAccordion.querySelector(
              '[data-gc-footer-accordion-icon]'
            );

            if (otherButton) {
              otherButton.setAttribute('aria-expanded', 'false');
            }

            if (otherIcon) {
              otherIcon.textContent = '+';
            }
          });

          accordion.classList.toggle('is-open', willOpen);
          button.setAttribute('aria-expanded', String(willOpen));

          if (icon) {
            icon.textContent = willOpen ? '−' : '+';
          }
        });
      });

      const countryForm = footer.querySelector(
        '.gc-2026-footer__country-form'
      );

      const countryToggle = footer.querySelector(
        '[data-gc-country-toggle]'
      );

      const countryPanel = footer.querySelector(
        '[data-gc-country-panel]'
      );

      const countryClose = footer.querySelector(
        '[data-gc-country-close]'
      );

      const countrySearch = footer.querySelector(
        '[data-gc-country-search]'
      );

      const countryCodeInput = footer.querySelector(
        '[data-gc-country-code]'
      );

      const countryOptions = Array.from(
        footer.querySelectorAll('[data-gc-country-option]')
      );

      let backdrop = null;

      const createBackdrop = () => {
        if (backdrop) return backdrop;

        backdrop = document.createElement('div');
        backdrop.className = 'gc-2026-country-backdrop';
        backdrop.setAttribute('aria-hidden', 'true');

        backdrop.addEventListener('click', () => {
          closeCountryPanel();
        });

        document.body.appendChild(backdrop);

        return backdrop;
      };

      const resetCountrySearch = () => {
        if (countrySearch) {
          countrySearch.value = '';
        }

        countryOptions.forEach((option) => {
          const listItem = option.closest('li');

          if (listItem) {
            listItem.hidden = false;
          }
        });
      };

      const applyMobilePopupState = () => {
        if (!countryPanel) return;

        if (window.innerWidth <= MOBILE_BREAKPOINT) {
          countryPanel.classList.add(
            'gc-2026-country-panel--mobile'
          );
        } else {
          countryPanel.classList.remove(
            'gc-2026-country-panel--mobile'
          );
        }
      };

      const closeCountryPanel = () => {
        if (!countryPanel || !countryToggle) return;

        countryPanel.hidden = true;
        countryToggle.setAttribute('aria-expanded', 'false');

        countryPanel.classList.remove(
          'gc-2026-country-panel--mobile'
        );

        backdrop?.classList.remove('is-visible');
        document.body.classList.remove(
          'gc-2026-country-popup-open'
        );

        resetCountrySearch();
      };

      const openCountryPanel = () => {
        if (!countryPanel || !countryToggle) return;

        applyMobilePopupState();

        countryPanel.hidden = false;
        countryToggle.setAttribute('aria-expanded', 'true');

        if (window.innerWidth <= MOBILE_BREAKPOINT) {
          const popupBackdrop = createBackdrop();

          popupBackdrop.classList.add('is-visible');

          document.body.classList.add(
            'gc-2026-country-popup-open'
          );
        }

        window.setTimeout(() => {
          countrySearch?.focus();
        }, 50);
      };

      countryToggle?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!countryPanel) return;

        if (countryPanel.hidden) {
          openCountryPanel();
        } else {
          closeCountryPanel();
        }
      });

      countryPanel?.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      countryClose?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        closeCountryPanel();
      });

      countrySearch?.addEventListener('input', () => {
        const query = countrySearch.value
          .trim()
          .toLowerCase();

        countryOptions.forEach((option) => {
          const searchableText = (
            option.dataset.gcCountrySearchText ||
            option.textContent ||
            ''
          ).toLowerCase();

          const listItem = option.closest('li');

          if (listItem) {
            listItem.hidden = !searchableText.includes(query);
          }
        });
      });

      countryOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const countryCode =
            option.dataset.gcCountryValue;

          if (
            !countryCodeInput ||
            !countryForm ||
            !countryCode
          ) {
            return;
          }

          countryCodeInput.value = countryCode;
          closeCountryPanel();
          countryForm.submit();
        });
      });

      document.addEventListener('click', (event) => {
        if (!countryPanel || countryPanel.hidden) return;

        if (
          !countryPanel.contains(event.target) &&
          !countryToggle?.contains(event.target)
        ) {
          closeCountryPanel();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (
          event.key === 'Escape' &&
          countryPanel &&
          !countryPanel.hidden
        ) {
          closeCountryPanel();
          countryToggle?.focus();
        }
      });

      const syncAccordionState = () => {
        if (window.innerWidth > MOBILE_BREAKPOINT) {
          accordions.forEach((accordion) => {
            accordion.classList.remove('is-open');

            const button = accordion.querySelector(
              '[data-gc-footer-accordion-button]'
            );

            const icon = accordion.querySelector(
              '[data-gc-footer-accordion-icon]'
            );

            if (button) {
              button.setAttribute('aria-expanded', 'true');
            }

            if (icon) {
              icon.textContent = '+';
            }
          });
        } else {
          accordions.forEach((accordion) => {
            const button = accordion.querySelector(
              '[data-gc-footer-accordion-button]'
            );

            if (button) {
              button.setAttribute(
                'aria-expanded',
                String(
                  accordion.classList.contains('is-open')
                )
              );
            }
          });
        }
      };

      const handleResize = () => {
        syncAccordionState();

        if (
          countryPanel &&
          !countryPanel.hidden
        ) {
          if (window.innerWidth <= MOBILE_BREAKPOINT) {
            applyMobilePopupState();

            createBackdrop().classList.add('is-visible');

            document.body.classList.add(
              'gc-2026-country-popup-open'
            );
          } else {
            countryPanel.classList.remove(
              'gc-2026-country-panel--mobile'
            );

            backdrop?.classList.remove('is-visible');

            document.body.classList.remove(
              'gc-2026-country-popup-open'
            );
          }
        }
      };

      syncAccordionState();

      window.addEventListener('resize', handleResize);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initFooter();
  });

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initFooter(event.target);
    }
  );
})();